let type_period = Object.freeze({
    list: [
        {value: '01', text: 'SEMANAL'},
        {value: '02', text: 'SEMANAL DE OPERACIONES'},
        {value: '03', text: 'QUINCENAL'},
        {value: '04', text: 'MENSUAL'},
        {value: '05', text: 'CATORCENAL'},
    ]
  });
  
  let status_period = Object.freeze({
    activo: 1,
    sin_calcular: 2,
    calculado_parcial: 3,
    calculado_total: 4,
    cerrado: 5,
    timbrado_parcial: 6,
    timbrado_total: 7,
    list: [
        {value: 1, text: 'Nuevo'},
        {value: 2, text: 'Sin Calcular'},
        {value: 3, text: 'Calculado Parcial'},
        {value: 4, text: 'Calculado Total'},
        {value: 5, text: 'Cerrado'},
        {value: 6, text: 'Timbrado Parcial'},
        {value: 7, text: 'Timbrado Total'},
    ]
  });
  
  module.exports = { type_period, status_period }
  